export type TenantId =
  | 'nourish'
  | 'myako'
  | 'palletways'
  | 'redcrier'
  | 'curvelearning';

export interface TenantBranding {
  appName: string;
  appShortName: string;
  appDescription: string;
  logoAlt: string;
  faviconPath?: string;
  adminPdfName: string;
  resellerPdfName?: string;
  apiBase: string;
}

export const TENANT_PRESETS: Record<TenantId, TenantBranding> = {
  nourish: {
    appName: 'Nourish Analytics',
    appShortName: 'Nourish',
    appDescription:
      'Nourish Analytics is a real-time monitoring and analytics platform that helps you track, analyze, and optimize operational alerts.',
    logoAlt: 'Logo',
    faviconPath: 'tenants/nourish/favicon.png',
    adminPdfName: 'Analytics',
    apiBase: 'https://analytics-be-2-0b3e.api.aime.works',
  },
  myako: {
    appName: 'myAko Analytics',
    appShortName: 'myAko',
    appDescription:
      'myAko Analytics is a real-time monitoring and analytics platform that helps you track, analyze, and optimize operational alerts.',
    logoAlt: 'Myako Logo',
    faviconPath: 'tenants/myako/favicon.ico',
    adminPdfName: 'Myako Analytics',
    resellerPdfName: 'Myako Analytics',
    apiBase: 'https://analytics-be-2-0b3e.api.aime.works',
  },
  palletways: {
    appName: 'Palletways Analytics',
    appShortName: 'Palletways',
    appDescription:
      'Palletways Analytics is a real-time monitoring and analytics platform that helps you track, analyze, and optimize operational alerts.',
    logoAlt: 'Palletways Logo',
    adminPdfName: 'Palletways Analytics',
    resellerPdfName: 'Palletways Analytics',
    apiBase: 'https://analytics-be-2-0b3e.api.aime.works',
  },
  redcrier: {
    appName: 'Redcrier Analytics',
    appShortName: 'Redcrier',
    appDescription:
      'RedCrier Analytics is a real-time monitoring and analytics platform that helps you track, analyze, and optimize operational alerts.',
    logoAlt: 'Logo',
    faviconPath: 'tenants/redcrier/favicon.ico',
    adminPdfName: 'Analytics',
    apiBase: 'https://analytics-be-2-0b3e.api.aime.works',
  },
  curvelearning: {
    appName: 'Curve Learning Analytics',
    appShortName: 'Curve Learning',
    appDescription:
      'Curve Learning Analytics is a real-time monitoring and analytics platform that helps you track, analyze, and optimize operational alerts.',
    logoAlt: 'Curve Learning Logo',
    faviconPath: 'tenants/curvelearning/favicon.png',
    adminPdfName: 'Curve Learning Analytics',
    resellerPdfName: 'Curve Learning Analytics',
    apiBase: 'https://analytics-be-2-0b3e.api.aime.works',
  },
};

export const TENANT_IDS = Object.keys(TENANT_PRESETS) as TenantId[];

export function isTenantId(id: string | null | undefined): id is TenantId {
  return typeof id === 'string' && TENANT_IDS.includes(id as TenantId);
}

export function resolveTenantId(): TenantId {
  return 'curvelearning';
}
